import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";

import { FramerTooltip } from "@ryde/controls";
import { TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { LiveMapDisplayModeDropdownWrapper } from "./live-map-display-mode.dropdown.styled";
import { LiveMapDisplayModeDropdownArea } from "./parts/live-map-display-mode.dropdown-area";
import { LiveMapDisplayModeIcon } from "./parts/live-map-display-mode.icon";
import { useLiveMapDisplayModeDropdown } from "./parts/use-live-map-display-mode-dropdown";

export const LiveMapDisplayModeDropdown: FC = () => {
  const hookData = useLiveMapDisplayModeDropdown();
  const { anchorRef, effectiveDisplayMode, togglePopover, tooltipContent } =
    hookData;

  return (
    <LiveMapDisplayModeDropdownWrapper>
      <FramerTooltip
        content={tooltipContent}
        placement={PopoverPlacement.top}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <button
          type="button"
          ref={anchorRef}
          className="live-map-display-mode-trigger"
          data-e2e="live-map-display-mode-trigger"
          aria-label={tooltipContent}
          onClick={togglePopover}
        >
          <LiveMapDisplayModeIcon displayMode={effectiveDisplayMode} />
        </button>
      </FramerTooltip>
      <LiveMapDisplayModeDropdownArea hookData={hookData} />
    </LiveMapDisplayModeDropdownWrapper>
  );
};
